import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import {
  type BaseQueryFnType,
  type ISupportTicketQuery,
  type ISupportTicket,
  type ISupportDetailsTicketQuery,
  type ISupportDetailsTicket,
  type IPostMessageQuery,
  type ICreateTicketQuery
} from './types'
import { SUPPORT_END_POINT } from './endpoints'
import { HEADERS_TITLE } from './constants'
import { getSupportTickets } from '../features/supportTicketsSlice'

const BASE_URL = process.env.REACT_APP_API_URL as string

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Accept', 'application/json')
      return headers
    }
  }) as BaseQueryFnType,
  endpoints: (builder) => ({
    getSupportTicket: builder.mutation<ISupportTicket, ISupportTicketQuery>({
      query ({ page = 0, perPage = 15 }) {
        return {
          url: SUPPORT_END_POINT.TICKET(page, perPage),
          method: 'GET',
          credentials: 'include'
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
      transformResponse: (res: ISupportTicket) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(getSupportTickets(data))
        } catch (error) {
          // console.error(error)
        }
      }
    }),
    getSupportDetailsTicket: builder.mutation<ISupportDetailsTicket, ISupportDetailsTicketQuery>({
      query ({ id }) {
        return {
          url: SUPPORT_END_POINT.TICKET_DETAILS(id),
          method: 'GET',
          credentials: 'include'
        }
      }
    }),
    postMessage: builder.mutation<[], IPostMessageQuery>({
      query: ({ content, token, id }) => {
        return {
          url: SUPPORT_END_POINT.TICKET_DETAILS_MESSAGE(id),
          method: 'POST',
          body: { content },
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    }),
    postTicket: builder.mutation<[], ICreateTicketQuery>({
      query: ({ reason, subject, description, token }) => {
        return {
          url: SUPPORT_END_POINT.TICKET_CREATE,
          method: 'POST',
          body: { reason, subject, description },
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    })
  })
})

export const {
  useGetSupportTicketMutation,
  useGetSupportDetailsTicketMutation,
  usePostMessageMutation,
  usePostTicketMutation
} = supportApi
